import {
    GET_ALL_PROJECTS_REQUEST,
    GET_ALL_PROJECTS_SUCCESS,
    GET_ALL_PROJECTS_FAIL,
    GET_ALL_PROJECTS_RESET,
    CREATE_PROJECT_REQUEST,
    CREATE_PROJECT_SUCCESS,
    CREATE_PROJECT_FAIL,
    CREATE_PROJECT_RESET,
    GET_RECENT_FILES_REQUEST,
    GET_RECENT_FILES_SUCCESS,
    GET_RECENT_FILES_FAIL,
    GET_RECENT_FILES_RESET,
    GET_FILES_REQUEST,
    GET_FILES_SUCCESS,
    GET_FILES_FAIL,
    GET_FILES_RESET,
    CREATE_FILE_REQUEST,
    CREATE_FILE_SUCCESS,
    CREATE_FILE_FAIL,
    CREATE_FILE_RESET,
    GET_BOOKMARK_FILES_REQUEST,
    GET_BOOKMARK_FILES_SUCCESS,
    GET_BOOKMARK_FILES_FAIL,
    GET_BOOKMARK_FILES_RESET,
    EDIT_FILE_REQUEST,
    EDIT_FILE_SUCCESS,
    EDIT_FILE_FAIL,
    EDIT_FILE_RESET,
    DELETE_FILE_REQUEST,
    DELETE_FILE_SUCCESS,
    DELETE_FILE_FAIL,
    DELETE_FILE_RESET,
    RENAME_FILE_REQUEST,
    RENAME_FILE_SUCCESS,
    RENAME_FILE_FAIL,
    RENAME_FILE_RESET,
    RENAME_FOLDER_REQUEST,
    RENAME_FOLDER_SUCCESS,
    RENAME_FOLDER_FAIL,
    RENAME_FOLDER_RESET,
    DUPLICATE_FILE_REQUEST,
    DUPLICATE_FILE_SUCCESS,
    DUPLICATE_FILE_FAIL,
    DUPLICATE_FILE_RESET,
    MOVE_FILE_REQUEST,
    MOVE_FILE_SUCCESS,
    MOVE_FILE_FAIL,
    MOVE_FILE_RESET,
} from '../constants/projectConstants'

export const allProjectsReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_ALL_PROJECTS_REQUEST:
            return { loading: true }
        case GET_ALL_PROJECTS_SUCCESS:
            return { loading: false, projectDetails: action.payload, success: true }
        case GET_ALL_PROJECTS_FAIL:
            return { loading: false, error: action.payload }
        case GET_ALL_PROJECTS_RESET:
            return {}
        default:
            return state
    }
}

export const createProjectReducer = (state = {}, action) => {
    switch (action.type) {
        case CREATE_PROJECT_REQUEST:
            return { loading: true }
        case CREATE_PROJECT_SUCCESS:
            return { loading: false, projectInfo: action.payload, success: true }
        case CREATE_PROJECT_FAIL:
            return { loading: false, error: action.payload }
        case CREATE_PROJECT_RESET:
            return {}
        default:
            return state
    }
}

export const allRecentFilesReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_RECENT_FILES_REQUEST:
            return { loading: true }
        case GET_RECENT_FILES_SUCCESS:
            return { loading: false, fileDetails: action.payload }
        case GET_RECENT_FILES_FAIL:
            return { loading: false, error: action.payload }
        case GET_RECENT_FILES_RESET:
            return {}
        default:
            return state
    }
}

export const allBookmarkFilesReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_BOOKMARK_FILES_REQUEST:
            return { loading: true }
        case GET_BOOKMARK_FILES_SUCCESS:
            return { loading: false, fileDetails: action.payload }
        case GET_BOOKMARK_FILES_FAIL:
            return { loading: false, error: action.payload }
        case GET_BOOKMARK_FILES_RESET:
            return {}
        default:
            return state
    }
}

export const allFilesReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_FILES_REQUEST:
            return { loading: true }
        case GET_FILES_SUCCESS:
            return { loading: false, allFileDetails: action.payload }
        case GET_FILES_FAIL:
            return { loading: false, error: action.payload }
        case GET_FILES_RESET:
            return {}
        default:
            return state
    }
}

export const createFileReducer = (state = {}, action) => {
    switch (action.type) {
        case CREATE_FILE_REQUEST:
            return { loading: true }
        case CREATE_FILE_SUCCESS:
            return { loading: false, fileInfo: action.payload, success: true }
        case CREATE_FILE_FAIL:
            return { loading: false, error: action.payload }
        case CREATE_FILE_RESET:
            return {}
        default:
            return state
    }
}

export const fileEditReducer = (state = {}, action) => {
    switch (action.type) {
        case EDIT_FILE_REQUEST:
            return { loading: true }
        case EDIT_FILE_SUCCESS:
            return { loading: false, editFileInfo: action.payload, success: true }
        case EDIT_FILE_FAIL:
            return { loading: false, error: action.payload }
        case EDIT_FILE_RESET:
            return {}
        default:
            return state
    }
}

export const fileDeleteReducer = (state = {}, action) => {
    switch (action.type) {
        case DELETE_FILE_REQUEST:
            return { loading: true }
        case DELETE_FILE_SUCCESS:
            return { loading: false, success: true, afterDelete: action.payload }
        case DELETE_FILE_FAIL:
            return { loading: false, error: action.payload }
        case DELETE_FILE_RESET:
            return {}
        default:
            return state
    }
}

export const fileRenameReducer = (state = {}, action) => {
    switch (action.type) {
        case RENAME_FILE_REQUEST:
            return { loading: true }
        case RENAME_FILE_SUCCESS:
            return { loading: false, renameFileInfo: action.payload, success: true }
        case RENAME_FILE_FAIL:
            return { loading: false, error: action.payload }
        case RENAME_FILE_RESET:
            return {}
        default:
            return state
    }
}

export const folderRenameReducer = (state = {}, action) => {
    switch (action.type) {
        case RENAME_FOLDER_REQUEST:
            return { loading: true }
        case RENAME_FOLDER_SUCCESS:
            return { loading: false, renameFolderInfo: action.payload, success: true }
        case RENAME_FOLDER_FAIL:
            return { loading: false, error: action.payload }
        case RENAME_FOLDER_RESET:
            return {}
        default:
            return state
    }
}

export const fileDuplicateReducer = (state = {}, action) => {
    switch (action.type) {
        case DUPLICATE_FILE_REQUEST:
            return { loading: true }
        case DUPLICATE_FILE_SUCCESS:
            return { loading: false, duplicateFileInfo: action.payload, success: true }
        case DUPLICATE_FILE_FAIL:
            return { loading: false, error: action.payload }
        case DUPLICATE_FILE_RESET:
            return {}
        default:
            return state
    }
}

export const fileMoveReducer = (state = {}, action) => {
    switch (action.type) {
        case MOVE_FILE_REQUEST:
            return { loading: true }
        case MOVE_FILE_SUCCESS:
            return { loading: false, moveFileInfo: action.payload, success: true }
        case MOVE_FILE_FAIL:
            return { loading: false, error: action.payload }
        case MOVE_FILE_RESET:
            return {}
        default:
            return state
    }
}


